import { render, staticRenderFns } from "./predict-table.vue?vue&type=template&id=15f98207&scoped=true&"
import script from "./predict-table.vue?vue&type=script&lang=js&"
export * from "./predict-table.vue?vue&type=script&lang=js&"
import style0 from "./predict-table.vue?vue&type=style&index=0&id=15f98207&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f98207",
  null
  
)

export default component.exports